import * as yup from 'yup';

export const QUESTION_TYPE = {
  shortAnswer: 1,
  longAnswer: 2,
  date: 3,
  number: 4,
  yesNo: 5,
  file: 6,
  option: 7,
  table: 8,
  contact: 9,
  statement: 99,
};

export const validationText = {
  [QUESTION_TYPE.contact]: 'Contact is required',
  [QUESTION_TYPE.date]: 'Date is required',
  [QUESTION_TYPE.file]: 'File is required',
  [QUESTION_TYPE.fullAnswer]: 'This field is required',
  [QUESTION_TYPE.longAnswer]: 'This field is required',
  [QUESTION_TYPE.number]: 'This field is required',
  [QUESTION_TYPE.option]: 'An option must be selected',
  [QUESTION_TYPE.shortAnswer]: 'This field is required',
  [QUESTION_TYPE.table]: 'Table entries are incomplete',
  [QUESTION_TYPE.yesNo]: 'Yes or no must be selected',
};

const getOptionValidation = ({ allowsMultiselect }) => {
  const optionRequiredMessage = validationText[QUESTION_TYPE.option];

  if (allowsMultiselect) {
    return yup
      .array()
      .of(
        yup.object().shape({
          value: yup.string().required(optionRequiredMessage),
          label: yup.string().required(),
        })
      )
      .min(1, optionRequiredMessage)
      .required(optionRequiredMessage);
  }

  return yup.string().required(optionRequiredMessage);
};

const getYesNoValidation = () => yup.boolean().required(validationText[QUESTION_TYPE.yesNo]);

const getFileValidation = () => {
  const requiredMessage = validationText[QUESTION_TYPE.file];

  return yup.mixed().test('file-upload-required', requiredMessage, (value) => {
    if (value && typeof value === 'boolean') {
      return true;
    } else if (value && value.length > 0) {
      return true;
    } else {
      return false;
    }
  });
};

const getTableValidation = () => yup.object().required(validationText[QUESTION_TYPE.table]);

const getContactValidation = () =>
  yup.array().min(1, validationText[QUESTION_TYPE.contact]).required(validationText[QUESTION_TYPE.contact]);

const questionTypeValidations = {
  [QUESTION_TYPE.option]: getOptionValidation,
  [QUESTION_TYPE.file]: getFileValidation,
  [QUESTION_TYPE.yesNo]: getYesNoValidation,
  [QUESTION_TYPE.table]: getTableValidation,
  [QUESTION_TYPE.contact]: getContactValidation,
};

export const getQuestionValidation = (props) => {
  const { questionTypeId } = props;

  return questionTypeValidations?.[questionTypeId]?.(props) || yup.string().required(validationText[questionTypeId]);
};

export const getQuestionVisible = (question, questionVisibility) => {
  question.isVisible = questionVisibility[question.questionId];
};

export const generateValidation = (sections, questionVisibility, isSectionHidden) => {
  const validation = {};
  if (isSectionHidden) {
    return validation;
  }

  sections?.forEach((section) => {
    section?.questions?.forEach((question) => {
      getQuestionVisible(question, questionVisibility);
      if (question.isVisible && question.isRequired && question.questionTypeId !== QUESTION_TYPE.statement) {
        const name = question.questionName;
        validation[name] = getQuestionValidation({
          allowsMultiselect: question?.allowsMultiselect,
          questionTypeId: question?.questionTypeId,
        });
      }
    });
  });
  return validation;
};
